import Header from './Header';


Header.install = function(Vue) {
  Vue.component(Header.name, Header);
};

export default Header;
